export default __webpack_public_path__ + "static/media/ru.23622fff.svg";